import React, { Component } from 'react';
import { Tag, Table, Popover } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';

import util from '@util/index';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  columns = () => {
    const typeFont = ['押金', '工位收入', '地址收入'];
    const payType = ['收入', '违约金', '退款'];
    const status = ['未付款', '部分匹配', '完成匹配'];
    const { data } = this.props;
    const termination = data.termination || {};
    const contractEndDate =
      termination.status === 1 && termination.endDate ? termination.beginDate : data.endDate;

    const renderMoney = (key, title, width) => {
      return {
        title,
        dataIndex: key,
        width: width || 150,
        render: text => <span>{text ? util.numberFormat(text) : 0}</span>,
      };
    };

    const renderDate = (key, title) => {
      return {
        title,
        dataIndex: key,
        width: 150,
        render: (text, record) => {
          if (key === 'date') {
            const date = record.payType === 2 ? contractEndDate : record.date;
            return <span>{text ? moment.unix(date / 1000).format('YYYY-MM-DD') : null}</span>;
          }
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : null}</span>;
        },
      };
    };

    return [
      {
        title: '账单基本情况',
        children: [
          {
            title: '账单编号',
            dataIndex: 'payableNo',
            width: 200,
            render: (text, record) => {
              const content = (
                <div>
                  <p>时间:{moment(record.sleepDate).format('YYYY-MM-DD')}</p>
                  <p>操作人员:{record.sleepUser}</p>
                  <p>原因:{record.sleepRemark}</p>
                </div>
              );
              return (
                <div>
                  {record.sleepStatus === 1 ? (
                    <Popover content={content}>
                      <Tag color="gray">休眠</Tag>
                    </Popover>
                  ) : (
                    ''
                  )}
                  <Link to={`/incubator/bill/${record.uuid}/detail`}>{text}</Link>
                </div>
              );
            },
          },
          {
            title: '对应租期',
            dataIndex: 'beginDate',
            width: 220,
            render: (text, record) =>
              record.beginDate && record.endDate ? (
                <span>
                  {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
                  {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
                </span>
              ) : null,
          },
          {
            title: '收入类型',
            dataIndex: 'type',
            width: 100,
            render: text => <span>{typeFont[text] || '其他'}</span>,
          },
          {
            title: '账单类型',
            dataIndex: 'payType',
            width: 100,
            render: (text, record) =>
              record.payType === 2 ? (
                <span style={{ color: 'red' }}>{payType[text]}</span>
              ) : (
                <span style={{ color: 'green' }}>{payType[text]}</span>
              ),
          },
        ],
      },
      {
        title: '款项情况',
        children: [
          renderMoney('initialPrice', '初始合同款'),
          {
            title: '待收/退',
            dataIndex: 'price',
            width: 90,
            render: (text, record) => {
              const element =
                record.payType === 2 ? (
                  <span style={{ color: 'red' }}>退{text ? util.numberFormat(text) : 0}</span>
                ) : (
                  <span style={{ color: 'green' }}>收{text ? util.numberFormat(text) : 0}</span>
                );
              return record.price > 0 ? element : <span>0</span>;
            },
          },
          {
            title: '已收/退',
            dataIndex: 'confirm',
            width: 100,
            render: (text, record) => {
              const confirm = Math.abs(record.confirm);
              const element =
                record.payType === 2 ? (
                  <span style={{ color: 'red' }}>退{text ? util.numberFormat(text) : 0}</span>
                ) : (
                  <span style={{ color: 'green' }}>收{text ? util.numberFormat(text) : 0}</span>
                );
              return confirm > 0 ? element : <span>0</span>;
            },
          },
          renderMoney('obsolete', '作废'),
        ],
      },
      {
        title: '押金',
        children: [
          {
            title: '押金',
            dataIndex: 'deposit',
            width: 100,
            render: (text, record, index) =>
              record.type === 0 ? <span>{text ? util.numberFormat(text) : 0}</span> : '-',
          },
          {
            title: '押金转违约金',
            dataIndex: 'liquidate',
            width: 150,
            render: (text, record, index) =>
              record.type === 0 ? <span>{text ? util.numberFormat(text) : 0}</span> : '-',
          },
          {
            title: '到期押金（被结转）',
            dataIndex: 'oldTurn',
            width: 200,
            render: (text, record, index) =>
              record.type === 0 ? <span>{text ? util.numberFormat(text) : 0}</span> : '-',
          },
        ],
      },
      {
        title: '支付情况',
        children: [
          renderMoney('shouldMatchTheFlow', '应匹配流水'),
          renderMoney('actualMatchTheFlow', '实匹配流水'),
        ],
      },
      {
        title: '款项状态',
        width: 100,
        dataIndex: 'status',
        render: (text, record, index) => {
          const stateElement =
            record.status === 2 ? (
              <span style={{ color: 'green' }}>{status[text]}</span>
            ) : (
              <span style={{ color: 'red' }}>{status[text]}</span>
            );

          const refundStateElement =
            record.status === 2 ? (
              <span style={{ color: 'green' }}>已匹配</span>
            ) : (
              <span style={{ color: 'red' }}>未匹配</span>
            );

          return record.payType !== 2 ? stateElement : refundStateElement;
        },
      },
      renderDate('date', '应收/付日期'),
      renderDate('confirmDate', '实收/付日期'),
      {
        title: '合同到期日期',
        dataIndex: 'termDate',
        width: 150,
        render: (text, record) => {
          const date = record.termDate || record.bussinessEndDate;
          return <span>{date ? moment.unix(date / 1000).format('YYYY-MM-DD') : null}</span>;
        },
      },
    ];
  };

  render() {
    const list = this.props.data.payables || [];
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={{ pageSize: 10 }}
        onChange={this.onTableChange}
        rowKey="uuid"
        bordered
        scroll={{ x: 2360 }}
      />
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/detail/TablePayable.js